import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export default function Error404() {
  return (
    <div className="flex flex-col min-h-[70vh] items-center justify-center px-4 text-center py-20 bg-white">
      <Helmet>
        <title>Siden blev ikke fundet - 404 - Hansen og Mortensen</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <span className="text-red-700 text-6xl sm:text-8xl font-black tracking-widest mb-4">
        404
      </span>
      <h1 className="text-2xl sm:text-4xl font-black text-neutral-950 uppercase tracking-tight mb-4">
        Siden blev ikke fundet
      </h1>
      <div className="w-16 h-1 bg-red-700 mb-6" />
      <p className="text-zinc-600 text-sm sm:text-base max-w-md leading-relaxed mb-10">
        Beklager, men den side du leder efter findes ikke, er blevet slettet eller har skiftet adresse.
      </p>

      <Link
        to="/"
        className="bg-red-700 hover:bg-red-800 text-white text-xs font-bold uppercase tracking-widest px-8 py-4 transition-all duration-300"
      >
        Gå til forsiden <i className="fa-solid fa-house ml-2 text-[10px]" />
      </Link>
    </div>
  )
}
